import { select, call, takeLatest, put } from 'redux-saga/effects';

import { IntakeSentActions } from '../constants';
import { IntakeSentApi } from 'src/services/end-points';
import {
    PersistIntakeInformedConsentForTestingAction,
    PersistIntakeInformedConsentForVideoAction,
    PersistIntakeMedicalReleaseAction,
    PersistIntakeOfficePoliciesAction,
    PersistIntakeSentAction,
    PersistIntakeTelemedicineConsentAction,
    PersistIntakeTreatmentInformedConsentAction,
    PersistIntakeAbaIntakeAction,
    PersistIntakeChildTreatmentQuestionnaireAction,
    PersistIntakeNeuropsychologyPatientAction,
    PersistIntakeConsentTestingDoeCasesAction,
    asyncPersistIntakeReleaseOfHealthInformationPediatrician,
    PersistIntakeReleaseOfHealthInformationPediatricianAction,
    PersistIntakeReleaseOfHealthInformationSchoolAction,
    PersistIntakeWelcomePacketAction,
    PersistIntakeBriefBackgroundAction,
    PersistIntakeTreatmentProcessAction,
    PersistIntakeInformedExpectationAction,
    PersistIntakeCreditCardAction,
    PersistIntakeHealthInformationAction, PersistIntakeConsentForBiAction,
} from '../actions/intakeSent-actions';
import {
    handleError,
    resolveApiCall,
    ResolverApiFailure,
    ResolverApiSuccess,
} from '../../services/api-handlers/api-resolver';
import { toast } from 'react-toastify';
import { getIntakes } from '../actions/student-actions';

function* handlePersistIntakeSent(action: PersistIntakeSentAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    //const dataIntakeSent = groupIntakeSent(restData);
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeSent(restData.student, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            //toast.success(`Intake form was successfully sent.`);

            //yield put(getStudent(restData.student));
            yield put(getIntakes(restData.student));
            yield call(callbacks.resolve);
            //yield resolveApiCall(action, () => StudentApi.getIntakesStudent(restData.student));
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeMedicalRelease(action: PersistIntakeMedicalReleaseAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    //const dataIntakeSent = groupIntakeSent(restData);
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeMedicalRelease(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeOfficePolicies(action: PersistIntakeOfficePoliciesAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    //const dataIntakeSent = groupIntakeSent(restData);
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeOfficePolicies(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeInformedConsentForTesting(action: PersistIntakeInformedConsentForTestingAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeInformedConsentForTesting(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeInformedConsentForVideo(action: PersistIntakeInformedConsentForVideoAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeInformedConsentForVideo(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeTelemedicineConsent(action: PersistIntakeTelemedicineConsentAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeTelemedicineConsent(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeConsentTestingDoeCases(action: PersistIntakeConsentTestingDoeCasesAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeConsentTestingDoeCases(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeTreatmentInformedConsent(action: PersistIntakeTreatmentInformedConsentAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeTreatmentInformedConsent(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeAbaIntake(action: PersistIntakeAbaIntakeAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    //const dataIntakeSent = groupIntakeSent(restData);
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeAbaIntake(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeChildTreatmentQuestionnaire(action: PersistIntakeChildTreatmentQuestionnaireAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    //const dataIntakeSent = groupIntakeSent(restData);
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeChildTreatmentQuestionnaire(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeNeuropsychologyPatient(action: PersistIntakeNeuropsychologyPatientAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    //const dataIntakeSent = groupIntakeSent(restData);
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeNeuropsychologyPatient(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeReleaseOfHealthInformationPediatrician(
    action: PersistIntakeReleaseOfHealthInformationPediatricianAction,
) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    //const dataIntakeSent = groupIntakeSent(restData);
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () =>
            IntakeSentApi.createIntakeReleaseOfHealthInformationPediatrician(
                restData.student,
                restData.formId,
                dataIntakeSent,
            ),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeReleaseOfHealthInformationSchool(
    action: PersistIntakeReleaseOfHealthInformationSchoolAction,
) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    //const dataIntakeSent = groupIntakeSent(restData);
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () =>
            IntakeSentApi.createIntakeReleaseOfHealthInformationSchool(
                restData.student,
                restData.formId,
                dataIntakeSent,
            ),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeWelcomePacket(action: PersistIntakeWelcomePacketAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    //const dataIntakeSent = groupIntakeSent(restData);
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeWelcomePacket(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeBriefBackground(action: PersistIntakeBriefBackgroundAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    //const dataIntakeSent = groupIntakeSent(restData);
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeBriefBackground(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeTreatmentProcess(action: PersistIntakeTreatmentProcessAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    //const dataIntakeSent = groupIntakeSent(restData);
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeTreatmentProcess(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeInformedExpectation(action: PersistIntakeInformedExpectationAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    //const dataIntakeSent = groupIntakeSent(restData);
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeInformedExpectation(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}


function* handlePersistIntakeCreditCard(action: PersistIntakeCreditCardAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    //const dataIntakeSent = groupIntakeSent(restData);
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeCreditCard(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}


function* handlePersistIntakeHealthInformation(action: PersistIntakeHealthInformationAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    //const dataIntakeSent = groupIntakeSent(restData);
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeHealthInformation(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

function* handlePersistIntakeConsentForBi(action: PersistIntakeConsentForBiAction) {
    const { payload } = action;
    const {
        data: { ...restData },
        callbacks,
    } = payload;
    //const dataIntakeSent = groupIntakeSent(restData);
    const dataIntakeSent = restData;
    yield resolveApiCall(
        action,
        () => IntakeSentApi.createIntakeConsentForBi(restData.student, restData.formId, dataIntakeSent),
        function* (data: ResolverApiSuccess) {
            toast.success(`The form was successfully sent.`);
            yield call(callbacks.resolve);
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (result.error && result.error.response && result.error.response.status) {
                    toast.error(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

export default function* () {
    yield takeLatest(IntakeSentActions.PERSIST_INTAKE_SENT, handlePersistIntakeSent);
    yield takeLatest(IntakeSentActions.PERSIST_MEDICAL_RELEASE, handlePersistIntakeMedicalRelease);
    yield takeLatest(IntakeSentActions.PERSIST_OFFICE_POLICIES, handlePersistIntakeOfficePolicies);
    yield takeLatest(
        IntakeSentActions.PERSIST_INFORMED_CONSENT_FOR_TESTING,
        handlePersistIntakeInformedConsentForTesting,
    );
    yield takeLatest(IntakeSentActions.PERSIST_INFORMED_CONSENT_FOR_VIDEO, handlePersistIntakeInformedConsentForVideo);
    yield takeLatest(IntakeSentActions.PERSIST_CONSENT_TESTING_DOE_CASES, handlePersistIntakeConsentTestingDoeCases);
    yield takeLatest(IntakeSentActions.PERSIST_TELEMEDICINE_CONSENT, handlePersistIntakeTelemedicineConsent);
    yield takeLatest(IntakeSentActions.PERSIST_TREATMENT_INFORMED_CONSENT, handlePersistIntakeTreatmentInformedConsent);
    yield takeLatest(IntakeSentActions.PERSIST_ABA_INTAKE, handlePersistIntakeAbaIntake);
    yield takeLatest(
        IntakeSentActions.PERSIST_CHILD_TREATMENT_QUESTIONNAIRE,
        handlePersistIntakeChildTreatmentQuestionnaire,
    );
    yield takeLatest(IntakeSentActions.PERSIST_INFORMED_EXPECTATION, handlePersistIntakeInformedExpectation);
    yield takeLatest(IntakeSentActions.PERSIST_CREDIT_CARD, handlePersistIntakeCreditCard);
    yield takeLatest(IntakeSentActions.PERSIST_HEALTH_INFORMATION, handlePersistIntakeHealthInformation);
    yield takeLatest(IntakeSentActions.PERSIST_CONSENT_FOR_BI, handlePersistIntakeConsentForBi);
    yield takeLatest(
        IntakeSentActions.PERSIST_RELEASE_OF_HEALTH_INFORMATION_PEDIATRICIAN,
        handlePersistIntakeReleaseOfHealthInformationPediatrician,
    );
    yield takeLatest(
        IntakeSentActions.PERSIST_RELEASE_OF_HEALTH_INFORMATION_SCHOOL,
        handlePersistIntakeReleaseOfHealthInformationSchool,
    );
    yield takeLatest(IntakeSentActions.PERSIST_WELCOME_PACKET, handlePersistIntakeWelcomePacket);
    yield takeLatest(IntakeSentActions.PERSIST_BRIEF_BACKGROUND, handlePersistIntakeBriefBackground);
    yield takeLatest(IntakeSentActions.PERSIST_TREATMENT_PROCESS, handlePersistIntakeTreatmentProcess);
    yield takeLatest(IntakeSentActions.PERSIST_NEUROPSYCHOLOGY_PATIENT, handlePersistIntakeNeuropsychologyPatient);
}
